import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "order-container" }
const _hoisted_2 = {
  key: 0,
  class: "order-item"
}
const _hoisted_3 = { class: "content-col" }
const _hoisted_4 = { class: "order-item" }
const _hoisted_5 = { class: "content-col" }
const _hoisted_6 = { class: "price-value" }
const _hoisted_7 = { class: "order-item" }
const _hoisted_8 = { class: "label-col" }
const _hoisted_9 = { class: "label-action" }
const _hoisted_10 = { class: "label-action" }
const _hoisted_11 = { class: "label-action" }
const _hoisted_12 = { class: "label-action" }
const _hoisted_13 = { class: "label-action" }
const _hoisted_14 = { class: "content-col" }
const _hoisted_15 = { class: "content-text" }
const _hoisted_16 = { class: "order-item-line" }
const _hoisted_17 = { class: "content-col-line" }
const _hoisted_18 = { class: "content-text" }
const _hoisted_19 = { class: "content-col-line" }
const _hoisted_20 = { class: "content-text" }
const _hoisted_21 = { class: "content-col-line" }
const _hoisted_22 = { class: "content-text" }
const _hoisted_23 = { class: "content-col-line" }
const _hoisted_24 = { class: "price-value" }
const _hoisted_25 = { class: "order-item" }
const _hoisted_26 = { class: "label-col" }
const _hoisted_27 = { class: "label-action" }
const _hoisted_28 = { class: "content-col" }
const _hoisted_29 = { class: "order-item" }
const _hoisted_30 = { class: "content-col" }
const _hoisted_31 = { class: "price-value" }
const _hoisted_32 = { class: "order-item" }
const _hoisted_33 = { class: "content-col" }
const _hoisted_34 = { class: "product-list" }
const _hoisted_35 = { class: "item-image" }
const _hoisted_36 = { class: "item-name" }
const _hoisted_37 = { class: "item-price" }
const _hoisted_38 = { class: "item-fright" }
const _hoisted_39 = { class: "item-quantity" }
const _hoisted_40 = { class: "order-item" }
const _hoisted_41 = { class: "content-col" }
const _hoisted_42 = { class: "price-value" }
const _hoisted_43 = { class: "order-item" }
const _hoisted_44 = { class: "content-col" }
const _hoisted_45 = { class: "content-text" }
const _hoisted_46 = { class: "order-item" }
const _hoisted_47 = { class: "content-col" }
const _hoisted_48 = { class: "content-text" }
const _hoisted_49 = { class: "order-item" }
const _hoisted_50 = { class: "label-col" }
const _hoisted_51 = { class: "label-action" }
const _hoisted_52 = { class: "content-col" }
const _hoisted_53 = { class: "content-text" }
const _hoisted_54 = { class: "span-text" }
const _hoisted_55 = { class: "span-text" }
const _hoisted_56 = { class: "span-text" }
const _hoisted_57 = { class: "span-text" }
const _hoisted_58 = { class: "order-item-line" }
const _hoisted_59 = { class: "content-col-line" }
const _hoisted_60 = { class: "content-text" }
const _hoisted_61 = { class: "content-col-line" }
const _hoisted_62 = { class: "content-text" }
const _hoisted_63 = { class: "content-col-line" }
const _hoisted_64 = { class: "content-text" }
const _hoisted_65 = { class: "order-item" }
const _hoisted_66 = { class: "label-action" }
const _hoisted_67 = { class: "order-item" }
const _hoisted_68 = { class: "label-col" }
const _hoisted_69 = { class: "label-action" }
const _hoisted_70 = { class: "content-col" }
const _hoisted_71 = { class: "content-text" }
const _hoisted_72 = { class: "span-text" }
const _hoisted_73 = { class: "span-text" }
const _hoisted_74 = { class: "span-text" }
const _hoisted_75 = { class: "span-text" }
const _hoisted_76 = { class: "order-item-line" }
const _hoisted_77 = { class: "content-col-line" }
const _hoisted_78 = { class: "content-text" }
const _hoisted_79 = { class: "content-col-line" }
const _hoisted_80 = { class: "content-text" }
const _hoisted_81 = { class: "content-col-line" }
const _hoisted_82 = { class: "content-text" }
const _hoisted_83 = { class: "content-col-line" }
const _hoisted_84 = { class: "content-text" }
const _hoisted_85 = { class: "order-item" }
const _hoisted_86 = { class: "content-col" }
const _hoisted_87 = { class: "price-value" }
const _hoisted_88 = { class: "order-item-line" }
const _hoisted_89 = { class: "content-col-line" }
const _hoisted_90 = { class: "content-text" }
const _hoisted_91 = { class: "content-col-line" }
const _hoisted_92 = { class: "content-text" }

import { ProductOrder } from "@/api/models/product_order/ProductOrder";
import { PropType } from "vue";
import { ToImage } from "@/utils/image";
import { message } from "ant-design-vue";
import { FileService } from "@/api/services/FileService";
import { countImage, countProduct } from "./count";
import dayjs from "dayjs";
import { onMounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDetail',
  props: {
  order: {
    type: Object as PropType<ProductOrder>,
    required: true,
  },
},
  setup(__props) {

const canvasRef = ref<HTMLCanvasElement | null>(null);
let ctx: CanvasRenderingContext2D | null = null;
let lineArray = ref<string[]>([]);
let pwidth = 750;
let totalPrint = 1;

const props = __props;

const getCategory = (write: number, category: number) => {
  // write 1在线，2手写，3钢笔 category：商品，信件，明信片
  var r = "";
  if (category === 1) {
    r = "商品订单";
  } else if (category === 2) {
    r = "信件订单";
  } else if (category === 3) {
    r = "明信片订单";
  }
  if (write === 1) {
    r += "  在线填写";
  } else if (write === 2) {
    r += "  手写拍照";
  } else if (write === 3) {
    r += "  钢笔代写";
  }
  return r;
};

const getContent = (
  title: string,
  content: string,
  author: string,
  write_date: string,
  send_province: string,
  send_city: string,
  send_district: string,
  send_address: string,
  phone: string,
  name: string
) => {
  return (
    title +
    "\n" +
    content +
    "\n" +
    send_province +
    send_city +
    send_district +
    send_address +
    "  " +
    phone +
    "  " +
    name +
    "\n" +
    author +
    "\n" +
    write_date
  );
};
const formatPrice = (price: number) => {
  return `￥${price.toFixed(2)}`;
};

const copyContent = async (content: string) => {
  await navigator.clipboard.writeText(content);
  message.success("复制成功");
};

const wrapText = (
  ctx: CanvasRenderingContext2D,
  context: string,
  maxWidth: number,
  lineHeight: number
) => {
  if (context.length == 0) return lineArray.value.length * lineHeight;
  // 针对中文：按字符分割
  const chars = context.split("");
  let line = "";
  let testLine = "";
  for (let i = 0; i < chars.length; i++) {
    testLine = line + chars[i];

    const metrics = ctx.measureText(testLine);
    const testWidth = metrics.width;

    // 如果超过最大宽度，保存当前行（最后一个字符不包含）
    if (testWidth > maxWidth && i > 0) {
      console.log(line);
      lineArray.value.push(line);
      line = chars[i]; // 新行从当前字符开始
    } else {
      line = testLine;
    }
  }
  console.log(line);
  lineArray.value.push(line);
  // 绘制所有行
  // for (let i = 0; i < lineArray.length; i++) {
  //   ctx.fillText(lineArray[i], x, y + i * lineHeight);
  //   if (i > 37) {
  //     // 一页最多37行
  //   }
  // }
  //alert(lineArray.value.length);
  return lineArray.value.length * lineHeight;
};
const setParam = async (
  title: string,
  content: string,
  author: string,
  write_date: string,
  send_province: string,
  send_city: string,
  send_district: string,
  send_address: string,
  phone: string,
  name: string
) => {
  const printCanvas = document.createElement("canvas");
  printCanvas.width = 795; // 打印区域的宽度
  printCanvas.height = 1135; // 打印区域的高度

  const printCtx = printCanvas.getContext("2d");
  lineArray.value.length = 0;
  if (printCtx) {
    printCtx.fillStyle = "black"; // 可以为打印区域添加背景色或其他装饰。
    printCtx.font = "20px Arial";
    printCtx.fillStyle = "black";
    //printCtx.fillText(title, 30, 50, 750);
    wrapText(printCtx, title, pwidth, 30);
    wrapText(printCtx, content, pwidth, 30);
    wrapText(printCtx, "\r\n", pwidth, 30);
    wrapText(
      printCtx,
      send_province +
        send_city +
        send_district +
        send_address +
        "," +
        phone +
        "," +
        name,
      pwidth,
      30
    );
    wrapText(printCtx, author, pwidth, 30);
    wrapText(printCtx, write_date, pwidth, 30);
    totalPrint = lineArray.value.length;
    //alert(totalPrint);
    message.success("制作完成，可以打印");
  }
};

const a4print = async (pcount: number, tempurl: string, rname: string) => {
  // 使用 ctx 进行绘图
  // 创建一个新的Canvas用于打印部分区域，例如打印上半部分
  if (pcount >= totalPrint) return;
  const printCanvas = document.createElement("canvas");
  printCanvas.width = 795; // 打印区域的宽度
  printCanvas.height = 1135; // 打印区域的高度

  const printCtx = printCanvas.getContext("2d");

  if (printCtx) {
    const image = new Image();
    image.src = ToImage(tempurl); // 替换为你的图片路径
    // image.src =
    //   "https://jxkapi.jixinkuai.com/api/file/2025/04/01/d0ce04ce-4e9f-4e4a-a86b-d450c27acab2.png";
    image.crossOrigin = "Anonymous";
    image.onload = () => {
      printCtx.drawImage(image, 0, 0, printCanvas.width, printCanvas.height);
      printCtx.fillStyle = "black"; // 可以为打印区域添加背景色或其他装饰。
      printCtx.font = "20px Arial";
      printCtx.fillStyle = "black";
      //printCtx.fillText(title, 30, 50, pwidth);
      for (let i = pcount; i < lineArray.value.length; i++) {
        if (lineArray.value.length - i <= 3) {
          // 靠右
          //printCtx.textAlign = "right";
          const textWidth = printCtx.measureText(lineArray.value[i]).width;
          // 设置x坐标为x值减去文本宽度，以实现右对齐
          const rightAlignedX = pwidth - textWidth;
          // 使用fillText方法绘制文本
          printCtx.fillText(
            lineArray.value[i],
            rightAlignedX,
            50 + (i - pcount) * 30
          );
          //printCtx.fillText(lineArray.value[i], 30, 50 + (i - pcount) * 30);
        } else {
          printCtx.fillText(lineArray.value[i], 30, 50 + (i - pcount) * 30);
        }
        if (i > 37 + pcount) {
          // 一页最多37行
          break;
        }
      }
      // printCtx.fillText(content, 30, 50, 750);
    };
    // printCtx.drawImage(canvas, 0, 0, 400, 200, 0, 0, 400, 200); // 从原Canvas的(0,0)开始，宽度400，高度200的区域复制到新Canvas的(0,0)位置，保持原图大小不变。
    // 可以选择直接打开新Canvas的图像或者进行其他处理，例如保存或打印等。

    //printCtx.fillRect(0, 0, printCanvas.width, printCanvas.height); // 例如，添加黑色背景。
    const win = window.open("", "_blank");
    printCanvas.toBlob((blob) => {
      if (blob != null) {
        //const url = URL.createObjectURL(blob);
        try {
          const dataUrl = printCanvas.toDataURL("image/png");
          const tile = rname + "家属的信件";
          if (win && dataUrl) {
            win.document.open();
            win.document.write(`
                <html>
                    <head>
                        <title>"${tile}"</title>
                    </head>
                    <body>
                        <img src="${dataUrl}" alt="Printed Canvas" />
                    </body>
                </html>
            `);

            win.document.close();
            setTimeout(() => {
              win.print();
              // 打印后关闭窗口（可选）
              win.close();
            }, 500);
          }
          //console.log(dataURL);
        } catch (error) {
          console.error("Failed to export canvas:", error);
        }
      }
    });
  }
  // 绘制指定区域的图像到新的Canvas上
  // 使用window.open打开新窗口显示打印内容（仅为示例，实际应用中可能需要根据需求调整）
};

const copyAddress = async (
  content: string,
  rName: string,
  rPhone: string,
  sName: string,
  sPhone: string,
  sRelationship: string
) => {
  var value;
  value = "收件人:\n";
  value += content;
  value += "\n   " + rName;
  value += "  " + rPhone;
  value += "\n----------------------------------------\n寄件人:\n";
  value += "广东省广州市黄埔区易博士大厦526(芳 18681417165)\n";
  value += "   " + sName;
  value += "  " + sPhone;
  value += " (关系:" + sRelationship + ")";
  await navigator.clipboard.writeText(value);
  message.success("复制成功");
};

const handleDownload = async () => {
  for (const image of props.order?.image_url) {
    await FileService.Download({ filename: image });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.order.template_image_url !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label-col" }, [
            _createElementVNode("span", { class: "label" }, "选择模板")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_image, {
              src: _unref(ToImage)(__props.order.template_image_url),
              width: "100px",
              class: "template-image",
              preview: true
            }, null, 8, ["src"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label-col" }, [
        _createElementVNode("span", { class: "label" }, "模板费用")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(formatPrice(__props.order.template_price)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "信件内容", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (
              setParam(
                __props.order.title,
                __props.order.content,
                __props.order.author,
                __props.order.write_date,
                __props.order.send_province,
                __props.order.send_city,
                __props.order.send_district,
                __props.order.send_address,
                __props.order.send_phone,
                __props.order.send_name
              )
            ))
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode(" 计算制作 ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (a4print(0, __props.order.template_image_url, __props.order.recipient_name)))
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" A4打印页面1 ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (a4print(37, __props.order.template_image_url, __props.order.recipient_name)))
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode(" A4打印页面2 ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (a4print(74, __props.order.template_image_url, __props.order.recipient_name)))
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode(" A4打印页面3 ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (
              copyContent(
                getContent(
                  __props.order.title,
                  __props.order.content,
                  __props.order.author,
                  __props.order.write_date,
                  __props.order.send_province,
                  __props.order.send_city,
                  __props.order.send_district,
                  __props.order.send_address,
                  __props.order.send_phone,
                  __props.order.send_name
                )
              )
            ))
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode(" 一键复制 ")
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(getContent(
              __props.order.title,
              __props.order.content,
              __props.order.author,
              __props.order.write_date,
              __props.order.send_province,
              __props.order.send_city,
              __props.order.send_district,
              __props.order.send_address,
              __props.order.send_phone,
              __props.order.send_name
            )), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "邮寄方式")
      ], -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(__props.order.mail_method_name), 1)
      ]),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "信件类型")
      ], -1)),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, _toDisplayString(getCategory(__props.order.write_category, __props.order.category)), 1)
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "代收")
      ], -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(__props.order.reply), 1)
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "邮寄费用")
      ], -1)),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("span", _hoisted_24, _toDisplayString(formatPrice(__props.order.mail_method_price)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "上传照片", -1)),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: handleDownload
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode(" 一键下载 ")
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.order.image_url, (i) => {
          return (_openBlock(), _createBlock(_component_a_image, {
            width: "200px",
            key: i,
            src: _unref(ToImage)(i)
          }, null, 8, ["src"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "label-col" }, [
        _createElementVNode("span", { class: "label" }, "图片费用")
      ], -1)),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("span", _hoisted_31, _toDisplayString(formatPrice(_unref(countImage)(__props.order.image_url))), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "label-col" }, [
        _createElementVNode("span", { class: "label" }, "商品列表")
      ], -1)),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"product-header\" data-v-92aa5d04><div class=\"header-item\" data-v-92aa5d04>商品图片</div><div class=\"header-item\" data-v-92aa5d04>商品名称</div><div class=\"header-item\" data-v-92aa5d04>商品单价</div><div class=\"header-item\" data-v-92aa5d04>商品运费</div><div class=\"header-item\" data-v-92aa5d04>商品数量</div></div>", 1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.order.items, (product) => {
            return (_openBlock(), _createElementBlock("div", {
              key: product.id,
              class: "product-item"
            }, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_a_image, {
                  src: _unref(ToImage)(product.image_url?.[0]),
                  class: "product-image",
                  preview: false
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_36, _toDisplayString(product.name), 1),
              _createElementVNode("div", _hoisted_37, _toDisplayString(formatPrice(product.price)), 1),
              _createElementVNode("div", _hoisted_38, _toDisplayString(formatPrice(product.fright)), 1),
              _createElementVNode("div", _hoisted_39, _toDisplayString(product.num), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "label-col" }, [
        _createElementVNode("span", { class: "label" }, "商品费用")
      ], -1)),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("span", _hoisted_42, _toDisplayString(formatPrice(_unref(countProduct)(__props.order?.items))), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "label-col" }, [
        _createElementVNode("span", { class: "label" }, "交易订单号")
      ], -1)),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, _toDisplayString(__props.order.order_id), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "label-col" }, [
        _createElementVNode("span", { class: "label" }, "物流订单号")
      ], -1)),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, _toDisplayString(__props.order.delivery_number), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "寄件人地址", -1)),
        _createElementVNode("div", _hoisted_51, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (
              copyContent(
                __props.order.send_province +
                  __props.order.send_city +
                  __props.order.send_district +
                  __props.order.send_address
              )
            ))
          }, {
            default: _withCtx(() => _cache[28] || (_cache[28] = [
              _createTextVNode(" 一键复制 ")
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("span", _hoisted_54, _toDisplayString(__props.order.send_province), 1),
          _createElementVNode("span", _hoisted_55, _toDisplayString(__props.order.send_city), 1),
          _createElementVNode("span", _hoisted_56, _toDisplayString(__props.order.send_district), 1),
          _createElementVNode("span", _hoisted_57, _toDisplayString(__props.order.send_address), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "寄件人姓名")
      ], -1)),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, _toDisplayString(__props.order.send_name), 1)
      ]),
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "寄件人电话")
      ], -1)),
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, _toDisplayString(__props.order.send_phone), 1)
      ]),
      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "寄件人地址邮编")
      ], -1)),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, _toDisplayString(__props.order.send_postcode), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createVNode(_component_a_button, {
          type: "primary",
          size: "small",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (
            copyAddress(
              __props.order.recipient_province +
                __props.order.recipient_city +
                __props.order.recipient_district +
                __props.order.recipient_address,
              __props.order.recipient_name,
              __props.order.recipient_phone,
              __props.order.send_name,
              __props.order.send_phone,
              __props.order.relationship
            )
          ))
        }, {
          default: _withCtx(() => _cache[33] || (_cache[33] = [
            _createTextVNode(" 一键复制所有 ")
          ])),
          _: 1
        })
      ]),
      _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "-------------------------------------------------------------------------------------------------分割线 ----------------------------------------------------------------------------------------------------------", -1))
    ]),
    _createElementVNode("div", _hoisted_67, [
      _createElementVNode("div", _hoisted_68, [
        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "收件人地址", -1)),
        _createElementVNode("div", _hoisted_69, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (
              copyContent(
                __props.order.recipient_province +
                  __props.order.recipient_city +
                  __props.order.recipient_district +
                  __props.order.recipient_address
              )
            ))
          }, {
            default: _withCtx(() => _cache[35] || (_cache[35] = [
              _createTextVNode(" 一键复制 ")
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("span", _hoisted_72, _toDisplayString(__props.order.recipient_province), 1),
          _createElementVNode("span", _hoisted_73, _toDisplayString(__props.order.recipient_city), 1),
          _createElementVNode("span", _hoisted_74, _toDisplayString(__props.order.recipient_district), 1),
          _createElementVNode("span", _hoisted_75, _toDisplayString(__props.order.recipient_address), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "收件人姓名")
      ], -1)),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, _toDisplayString(__props.order.recipient_name), 1)
      ]),
      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "收件人电话")
      ], -1)),
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", _hoisted_80, _toDisplayString(__props.order.recipient_phone), 1)
      ]),
      _cache[39] || (_cache[39] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "关系")
      ], -1)),
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, _toDisplayString(__props.order.relationship), 1)
      ]),
      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "收件地址邮编")
      ], -1)),
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("div", _hoisted_84, _toDisplayString(__props.order.recipient_postcode), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_85, [
      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "label-col" }, [
        _createElementVNode("span", { class: "label" }, "总费用")
      ], -1)),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("span", _hoisted_87, _toDisplayString(formatPrice(__props.order.total_price)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_88, [
      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "支付时间")
      ], -1)),
      _createElementVNode("div", _hoisted_89, [
        _createElementVNode("div", _hoisted_90, _toDisplayString(_unref(dayjs)(__props.order.create_at).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "label-col-line" }, [
        _createElementVNode("span", { class: "label" }, "修改时间")
      ], -1)),
      _createElementVNode("div", _hoisted_91, [
        _createElementVNode("div", _hoisted_92, _toDisplayString(_unref(dayjs)(__props.order.update_at).format("YYYY-MM-DD HH:mm:ss")), 1)
      ])
    ])
  ]))
}
}

})